export const VENDOR_CATEGORIES = [
  {
    key: 'photographer',
    label: 'Photographer',
  },
  {
    label: 'Videographer',
    key: 'videographer',
  },
  {
    key: 'florist',
    label: 'Florist',
  },
  {
    key: 'celebrant',
    label: 'Celebrant',
  },
  {
    key: 'transport-and-cars',
    label: 'Transport and Cars',
  },
  {
    key: 'venue',
    label: 'Venue',
  },
  {
    key: 'musician',
    label: 'Musician',
  },
  {
    label: 'Hair',
    key: 'hair',
  },
  {
    label: 'Make Up',
    key: 'makeup',
  },
  {
    label: 'Hair & Make Up',
    key: 'hair+makeup',
  },
  {
    label: 'Photobooth',
    key: 'photobooth',
  },
  {
    label: 'Wedding Dresses',
    key: 'gowns-and-dresses',
  },
  {
    label: 'Formal Wear',
    key: 'formal-wear',
  },
  {
    label: 'Stylist',
    key: 'stylist',
  },
  {
    label: 'DJ',
    key: 'dj',
  },
  {
    label: 'Caterer',
    key: 'caterer',
  },
  {
    label: 'Invitations',
    key: 'invitations',
  },
  {
    label: 'MC',
    key: 'mc',
  },
  {
    label: 'Cakes',
    key: 'cakes',
  },
  {
    key: 'other',
    label: 'Other',
  },
];

export const getVendorCategory = key => {
  return VENDOR_CATEGORIES.find(o => o.key === key);
};

export const getVendorCategoryLabel = key => getVendorCategory(key).label;
